import { render, staticRenderFns } from "./VGoal.vue?vue&type=template&id=1bb87a92&"
import script from "./VGoal.vue?vue&type=script&lang=js&"
export * from "./VGoal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports